import Router from '../router'
export default {
  payFee: (state) => {
    const {amount, addFee, fee, payType, budget, expressType} = state
    if (fee.diagnosisFee) { // 医疗
      if (payType) {
        return (Number(fee.serviceFee) * 100 + Number(addFee) * 100 + Number(fee.premiumFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
      } else {
        return (Number(fee.serviceFee) * 100 + Number(addFee) * 100 + Number(fee.diagnosisFee) * 100 + Number(fee.premiumFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
      }
    } else if (fee.nightPrice || fee.nightPrice == 0) { // 其他
      return (Number(fee.serviceFee) * 100 + Number(addFee) * 100 + Number(fee.nightPrice) * 100 + Number(fee.premiumFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
    } else if(fee.premiumFee || fee.premiumFee == 0) {
      return (Number(fee.serviceFee) * 100 + Number(addFee) * 100 + Number(fee.premiumFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
    } else {
      if(Router.app._route.fullPath == '/courier/ticketOrder') {
        return (Number(fee.serviceFee) * 100 + Number(addFee) * 100 + Number(fee.premiumFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
      }
      return 0
    }
  }

  // else if (!fee.diagnosisFee) { // 没有诊金
  //   return (Number(fee.serviceFee) * 100 + Number(fee.premiumFee) * 100 + Number(budget) * 100 + Number(addFee) * 100 - Number(amount.amount) * 100) / 100
  // } else if (!fee.premiumFee) { // 没有溢价
  //   if (payType) {
  //     console.log(454)
  //     return (Number(fee.serviceFee) * 100 + Number(addFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
  //   } else {
  //     return (Number(fee.serviceFee) * 100 + Number(fee.diagnosisFee) * 100 + Number(addFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
  //   }
  // } else {
  //   if (payType) {
  //     console.log(454)
  //     return (Number(fee.serviceFee) * 100 + Number(addFee) * 100 + Number(fee.premiumFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
  //   } else {
  //     return (Number(fee.serviceFee) * 100 + Number(fee.diagnosisFee) * 100 + Number(addFee) * 100 + Number(fee.premiumFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
  //   }
  //   // return (Number(fee.serviceFee) * 100 + Number(fee.diagnosisFee) * 100 + Number(fee.premiumFee) * 100 + Number(addFee) * 100 + Number(budget) * 100 - Number(amount.amount) * 100) / 100
  // }
}



// WEBPACK FOOTER //
// ./src/store/getters.js